var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.active)?_c('small-alert',{attrs:{"item":_vm.current}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }